import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'class-names'
import without from 'lodash.without'
import {
  getRecommendation,
  saveSpecialtyIntention,
  recommendSpecialty,
  clearSpecialtyIntention
} from '../../api/majorWishList'
import Popup from '../../components/Popup'
import MajorList from '../../components/MajorList/indexNew'
import Toast from '../../components/Toast'
import OperationBtn from './OperationBtn'
import introBg from '../../assets/svg/fig.svg';
import packUpIcon from '../../assets/svg/icon-packup.svg';
import './Selected.less'

const MAX_MAJOR_COUNT = 40

class MajorWishList extends Component {

  static propTypes = {
    codes: PropTypes.array,
    changeCodes: PropTypes.func,
  }

  state = {
    showIntro: false,
    showWarn: false,
    majorList: [],
    classifyList: [],
    showToast: false,
    toastText: '',
    majorCount: 0,
    showConfirm: false,
    showMore:true,
  }

  componentDidMount() {
    const { codes } = this.props
    // debugger
    this.getMajorList(codes)
  }

  componentDidUpdate(prevProps) {
    const { codes } = this.props;
    if (prevProps.codes !== codes) {
      this.getMajorList(codes)
    }
  }
  componentWillReceiveProps(n) {
    // console.log(n);
    // debugger
  }
  getMajorList(codes) {
    if (codes.length) {
      getRecommendation(codes.join(',')).then(({ data }) => {
        const classifyMap = new Map()
        data.forEach(d => {
          if (classifyMap.has(d.classify.id)) {
            classifyMap.get(d.classify.id).children.push(d)
          } else {
            classifyMap.set(d.classify.id, d.classify)
            d.classify.children = [d]
          }
        })
        this.setState({
          majorList: data,
          classifyList: Array.from(classifyMap.values()),
          majorCount: data.length,
        })
      })
    } else {
      this.setState(() => {
        return {
          majorList: [],
          classifyList: [],
          majorCount: 0,
        }
      })
    }
  }
  //点击查看专业详情
  handleMajorClick(major) {
    const { history } = this.props
    history.push(`/majorwishlist/major/${major.id}`)
  }
  //添加其他你喜欢的专业
  handleChooseMajor() {
    const { history, match } = this.props
    history.push(`${match.url}/choose`)
  }

  //增加/删除
  handleRemoveMajor(obj, e) {
    e.stopPropagation()
    const { codes } = this.props
    const deletedCodes = obj.code
      ? [obj.code]
      : obj.children.map(d => d.code)
    const newCodes = without(codes, ...deletedCodes)
    this.props.changeCodes(newCodes, 'selected')
    this.setState(() => {
      return {
        showToast: true,
        toastText: obj.name,
      }
    })
  }
  //重置提示框
  handleResetCodes() {
    this.setState({
      showConfirm: true,
    });
  }
  //重置专业至hld推荐专业
  handleConfirmResetCodes() {
    recommendSpecialty().then((res) => {
      if (!res) return;
      window.location.href = res.data.specialty_url + '&type=reset';
      this.setState({
        showConfirm: false,
      });
    })
    // clearSpecialtyIntention().then(() => {
    //   this.props.changeCodes([]);
    //   this.setState({
    //     showConfirm: false,
    //   });
    // })
  }
  //下一步
  handleNext() {
    const { majorList, majorCount } = this.state
    const majorIds = majorList.map(d => d.id);
    const { match, history } = this.props;
    if (majorCount > MAX_MAJOR_COUNT) {
      this.setState(() => {
        return {
          showWarn: true,
        }
      })
    }else if(majorCount===0){
        clearSpecialtyIntention().then(res=>{
            history.push(`/schoolwishlist`)
        })
    } else {
      saveSpecialtyIntention(majorIds).then(res => {
          history.push(`/schoolwishlist`);
      })
    }
  }

  renderRightIcon(data) {
    return <OperationBtn added onClick={this.handleRemoveMajor.bind(this, data)} />
  }

  render() {
    const {
      showIntro,
      classifyList,
      showToast,
      toastText,
      showWarn,
      majorCount,
      showConfirm,
      showMore,
    } = this.state
    const nextStep = majorCount <= MAX_MAJOR_COUNT
    return (
      <div className="major-wish-list-wrapper major-selected-wrapper">
        <div className="detail-banner">
          <h1>
              <span>意向专业清单</span>
              {/*<i className="icon-question" onClick={() => this.setState({ showIntro: true })} />*/}
            {/*<div className="btn-reset" onClick={this.handleResetCodes.bind(this)}>重置</div>*/}
          </h1>
          <div className={showMore?'':'bottom'} >
            {
              showMore?
                  <p>我们已经根据测评结果，为你挑选了一些专业，你也可以在专业库中，挑选其他专业。为了更好的做出选科决策，你最多可选定40个你最感兴趣的专业。</p>
                  :
                  <p className='limit' style={{WebkitBoxOrient:'vertical'}}>我们已经根据测评结果，为你挑选了一些专业，你也可以在专业库中，挑选其他专业。为了更好的做出选科决策，你最多可选定40个你最感兴趣的专业。</p>
            }
            <div className={`operate-more ${showMore?'operate-packup':'operate-expand'}`} onClick={()=>{
              this.setState({showMore:!showMore})
            }}>{showMore?'收起':'展开'}<img src={packUpIcon} alt=""/></div>
          </div>
        </div>
        <div className="reset" onClick={this.handleResetCodes.bind(this)}>如有需要，你也可以随时将清单<span>重置为系统推荐专业</span></div>
        <MajorList
          classifyList={classifyList}
          onMajorClick={this.handleMajorClick.bind(this)}
          rightIcon={this.renderRightIcon.bind(this)}
        />
        <div className="padding-btn">
          <button className="full" onClick={this.handleChooseMajor.bind(this)}>添加其他你喜欢的专业</button>
        </div>
        <div className={classNames({ 'next-step': true, 'disabled': !nextStep })}
             onClick={this.handleNext.bind(this)}>
            <p>{!nextStep ? '请继续减少清单中的专业数量' : '点击进入下一步'}</p>
            <i>{majorCount} / {MAX_MAJOR_COUNT}</i>
        </div>
        <Popup confirmText="确认" show={showIntro} onConfirm={() => this.setState({ showIntro: false })}>
          <div>
            <img className="intro-bg" src={introBg} alt="intro_bg" />
            <div className="wish-list-intro">
              <h3>什么是专业意向清单</h3>
              <p>意向专业清单的初始专业内容源自于你的测评结果，希望你先去了解这些专业哦，然后筛选和删除填报意向不高的专业。</p>
              <p>当然，你有最大的自由度可以在专业意向清单中新增其它专业。最终你确认的清单会影响你的选科分析结果哦。</p>
            </div>
          </div>
        </Popup>
        <Popup confirmText={'我知道了'} show={showWarn} onConfirm={() => this.setState({ showWarn: false })}>
          <div className="popup-warn">
            <p>当前你所添加的意向专业一共{majorCount}个，请继续了解不同的专业，将意向的专业缩减至{MAX_MAJOR_COUNT}个</p>
          </div>
        </Popup>
        <Popup
          show={showConfirm}
          confirmText="确认重置"
          cancelText="取消"
          onConfirm={this.handleConfirmResetCodes.bind(this)}
          onCancel={() => this.setState({ showConfirm: false })}>
          <div className="popup-warn">
            <p>重置将会清除你目前在意向专业清单中所做的修改，并将清单的内容恢复成系统推荐专业。</p>
          </div>
        </Popup>
        <Toast show={showToast} icon={'deleted'} onHide={() => this.setState({ showToast: false })}>
          <i>已删除</i>
          <p>{toastText}</p>
        </Toast>
      </div>
    )
  }
}

export default MajorWishList



// WEBPACK FOOTER //
// ./src/pages/MajorWishList/Selected.js